import type { CSSProperties, ReactNode } from 'react';

export const DECK_CARD_WIDTH = 26;

export const PDF_DECK_GROUP = 'group/pdf-deck';

const CARD =
	'border-h-neutral-90 absolute bottom-0 left-0 h-[34px] w-[26px] origin-bottom-left rounded-[3px] border bg-white shadow-sm transition-transform duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] motion-reduce:transition-none';

const BACK_CARD =
	'[transform:translate(calc(var(--depth)*3px),calc(var(--depth)*-2px))_rotate(calc(var(--depth)*5deg))] group-hover/pdf-deck:[transform:translate(calc(var(--depth)*4px),calc(var(--depth)*-3px))_rotate(calc(var(--depth)*11deg))] group-active/pdf-deck:[transform:translate(calc(var(--depth)*4px),calc(var(--depth)*-3px))_rotate(calc(var(--depth)*11deg))]';

const FRONT_CARD =
	'overflow-hidden group-hover/pdf-deck:[transform:translateY(-3px)_rotate(-5deg)] group-active/pdf-deck:[transform:translateY(-3px)_rotate(-5deg)]';

const PdfDeckFrame = ({ behind = 0, children }: { behind?: number; children?: ReactNode }) => (
	<span
		aria-hidden
		className={`${PDF_DECK_GROUP} relative block size-10 shrink-0`}>
		{Array.from({ length: behind }, (_, index) => {
			const depth = behind - index;
			return (
				<span
					key={depth}
					className={`${CARD} ${BACK_CARD}`}
					style={{ '--depth': depth } as CSSProperties}
				/>
			);
		})}
		<span className={`${CARD} ${FRONT_CARD}`}>{children ?? <span className='bg-h-neutral-94 block size-full animate-pulse' />}</span>
	</span>
);

export default PdfDeckFrame;
